import { createConnectedStore } from "undux";
import { AMAZON_REGION } from "./stores/Amazon";
import { Platform, STORES } from "./utils";

// We use a budget version of redux/React context called undux

export type StoreType = {
  orgName: string;
  orgId: string;
  nonce: string;
  publicKey: string;
  origin: string;
  isSandbox: boolean;
  keyInvalid: boolean;
  platforms: any[];
  organization: Organization | null;
  isUpdate: boolean; // if this an existing connection (or created by POST /connections/create)
  itemId: string; // the itemId for the existing connection, set in ConnectionContainer
  skipOverride: boolean; // temporary workaround to unskip "loading" check when initializing Teller Connect.
  environment: string; // Environment override to be used for Teller Connect. Default is "production".
  shopifyStoreUrl: string;
  bigCommerceStoreUrl: string;
  autoPlatform: string | null;
  autoShopifyStore: string | null;
  customRedirectUrl: string;
  customReturnUrl: string;
  usage: string | null;
  handleSandboxComplete: () => void;
  platformData: {
    storeName: string | null;
    region: AMAZON_REGION | null;
  };
  autoLoad: boolean;
  authenticationConfigs: any;
  store: STORES | null;
  platform: Platform | null;
};

export type Organization = {
  id: string;
  name: string;
  emergencyDeveloperEmail: string;
  privateShopifyScopes: string;
  isPrivateShopify: boolean;
  bigCommerceScopes: string;
  isPrivateBigCommerce: boolean;
  linkLogoUrl: string | null;
  linkText: string | null;
  platformPageText?: string;
  additionalPrivacyPolicyLink?: string;
  additionalTermsLink?: string;
  prestashopScopes?: string;
  platformPageConnectUnderText?: string;
  whitelabelOptions?: any; // Look at backend Organization.ts entity
};

// Create a store with an initial value.
export default createConnectedStore<StoreType>({
  orgName: "",
  orgId: "",
  nonce: "",
  publicKey: "",
  origin: "",
  isSandbox: false,
  keyInvalid: false,
  platforms: [],
  organization: null,
  shopifyStoreUrl: "",
  bigCommerceStoreUrl: "",
  itemId: "",
  skipOverride: false,
  environment: "",
  isUpdate: false,
  autoPlatform: null,
  autoShopifyStore: null,
  customRedirectUrl: "",
  customReturnUrl: "",
  usage: null,
  handleSandboxComplete: () => {},
  platformData: {
    storeName: null,
    region: null,
  },
  autoLoad: false,
  authenticationConfigs: null,
  store: null,
  platform: null,
});
